<nb-card class="write-cta-on-image-choice">
  <nb-card-header>
    Choisissez la forme de votre CTA et placez-le sur le visuel
  </nb-card-header>
  <nb-card-body>
    <div class="write-cta-on-image-options">
      @if (isLoading || !ctaOptions.length) {
        <div class="loading-container">
          <div class="loading-spinner">
            <div class="spinner"></div>
          </div>
        </div>
      }

      <div [hidden]="isLoading || !ctaOptions.length || !staticImageUrl">
        <div class="overlay-container" #overlayContainer>
          <img [src]="staticImageUrl" class="static-image" #staticImgEl>
          <div class="overlay-wrapper">
            <img #overlayImg
              [src]="currentOverlayUrl"
              class="overlay-image"
              (load)="onOverlayLoad()"
              (mousedown)="onImageMouseDown($event)" />
            <div class="resize-handle top-left" (mousedown)="onResizeHandleDown($event, 'nw')"></div>
            <div class="resize-handle top-right" (mousedown)="onResizeHandleDown($event, 'ne')"></div>
            <div class="resize-handle bottom-left" (mousedown)="onResizeHandleDown($event, 'sw')"></div>
            <div class="resize-handle bottom-right" (mousedown)="onResizeHandleDown($event, 'se')"></div>
          </div>
        </div>

        <div class="thumbnail-container">
          @for (option of ctaOptions; track option.style) {
            <div class="thumbnail"
              [class.active]="selectedOption?.style === option.style"
              (click)="selectOption(option)">
              <img [src]="option.url" [alt]="option.label">
              <span>{{ option.label }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer class="footer-buttons">
    <button nbButton status="danger" [disabled]="loading || isLoading" (click)="cancel()">Annuler</button>
    <div class="right-buttons">
      <button nbButton status="success" [disabled]="loading || isLoading" (click)="confirm()">
        <div class="button-content">
          Confirmer
          @if (loading) {
            <div class="loading-spinner"></div>
          }
        </div>
      </button>
    </div>
  </nb-card-footer>
</nb-card>
